export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-plane-line text-3xl text-teal-400"></i>
              </div>
              <span className="text-xl font-bold">USATravelGuide</span>
            </div>
            <p className="text-sm text-gray-400 mb-4 leading-relaxed">
              Chuyên trang hướng dẫn du lịch Mỹ toàn diện với kinh nghiệm từ các chuyên gia hàng đầu. 
              Giúp bạn có chuyến đi an toàn và trọn vẹn nhất.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center bg-gray-800 rounded-lg hover:bg-gray-700 transition-colors">
                <i className="ri-facebook-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center bg-gray-800 rounded-lg hover:bg-gray-700 transition-colors">
                <i className="ri-youtube-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center bg-gray-800 rounded-lg hover:bg-gray-700 transition-colors">
                <i className="ri-instagram-line"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Hướng dẫn</h3>
            <ul className="space-y-3">
              <li><a href="/visa-us-guide" className="text-sm text-gray-400 hover:text-white transition-colors">Visa du lịch Mỹ</a></li>
              <li><a href="/travel-insurance-guide" className="text-sm text-gray-400 hover:text-white transition-colors">Bảo hiểm du lịch</a></li>
              <li><a href="/car-rental-guide" className="text-sm text-gray-400 hover:text-white transition-colors">Thuê xe tại Mỹ</a></li>
              <li><a href="#" className="text-sm text-gray-400 hover:text-white transition-colors">Chi phí dự trù</a></li>
              <li><a href="#" className="text-sm text-gray-400 hover:text-white transition-colors">Mẹo tiết kiệm</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Dịch vụ</h3>
            <ul className="space-y-3">
              <li><a href="#" className="text-sm text-gray-400 hover:text-white transition-colors">Tư vấn visa</a></li>
              <li><a href="#" className="text-sm text-gray-400 hover:text-white transition-colors">Tư vấn bảo hiểm</a></li>
              <li><a href="#" className="text-sm text-gray-400 hover:text-white transition-colors">Tour du lịch Mỹ</a></li>
              <li><a href="#" className="text-sm text-gray-400 hover:text-white transition-colors">Hỗ trợ khẩn cấp</a></li>
              <li><a href="#" className="text-sm text-gray-400 hover:text-white transition-colors">Đặt vé máy bay</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Liên hệ</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-sm text-gray-400">
                <i className="ri-phone-line"></i>
                <span>Hotline: 1900-xxxx</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-gray-400">
                <i className="ri-mail-line"></i>
                <span>info@usatravelguide.com</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-gray-400">
                <i className="ri-map-pin-line mt-0.5"></i>
                <span>Tầng 10, Tòa nhà ABC<br />123 Đường XYZ, Quận 1, TP.HCM</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-gray-400">
                <i className="ri-time-line"></i>
                <span>24/7 - Hỗ trợ khẩn cấp</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-sm text-gray-400">
              © 2025 USATravelGuide. Bảo lưu mọi quyền. 
              <a href="https://readdy.ai/?origin=logo" className="text-teal-400 hover:text-teal-300 transition-colors ml-2">
                Powered by Readdy
              </a>
            </div>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">Điều khoản</a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">Bảo mật</a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">Cookie</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}